import { useEffect } from "react";

const TITLE = "KG POS管理";

export const useTitle = (title: string): void => {
  useEffect(() => {
    document.title = `${TITLE} - ${title}`;
  }, [title]);
};
